import { ServiceIdentifier } from './ServiceIdentifier';
var connectionManagerType = new ServiceIdentifier("Neo.ConnectionManager");
// Neo Module Type Symbols
var NeoTypes = {
    Axios: new ServiceIdentifier("Neo.Axios"),
    Config: {
        ConfigModel: new ServiceIdentifier("Neo.ConfigModel"),
        ConfigService: new ServiceIdentifier("Neo.ConfigService")
    },
    Core: {
        AutoRunnerFactory: new ServiceIdentifier("Neo.AutoRunnerFactory"),
        /** @deprecated Use Messaging.ConnectionManager */
        ConnectionManager: connectionManagerType,
        DecimalService: new ServiceIdentifier("Neo.DecimalService"),
        ModelCreator: new ServiceIdentifier("Neo.ModelCreator")
    },
    Localisation: {
        LocalisationService: new ServiceIdentifier("Neo.Localisation")
    },
    Messaging: {
        ConnectionManager: connectionManagerType,
        ServerMessageSubscriber: new ServiceIdentifier("Neo.ServerMessageSubscriber"),
    },
    Routing: {
        MenuItemProvider: new ServiceIdentifier("Neo.MenuItemProvider"),
        NavigationHelper: new ServiceIdentifier("Neo.NavigationHelper"),
        PageLeaveHandler: new ServiceIdentifier("Neo.PageLeaveHandler"),
        RouteSecurityService: new ServiceIdentifier("Neo.RouteSecurityService"),
    },
    Security: {
        AuthenticationService: new ServiceIdentifier("Neo.AuthenticationService"),
        AuthorisationService: new ServiceIdentifier("Neo.AuthorisationService"),
        LoginErrorHandler: new ServiceIdentifier("Neo.LoginErrorHandler"),
        SecurityService: new ServiceIdentifier("Neo.SecurityService")
    },
    TaskRunner: new ServiceIdentifier("Neo.Services.TaskRunner"),
    UI: {
        ErrorHandler: new ServiceIdentifier("Neo.UI.ErrorHandler"),
        GlobalContextMenuState: new ServiceIdentifier("Neo.UI.GlobalContextMenuState"),
        GlobalNotifications: new ServiceIdentifier("Neo.UI.GlobalNotifications"),
        ModalStore: new ServiceIdentifier("Neo.UI.ModalStore"),
        NotificationHelper: new ServiceIdentifier("Neo.UI.NotificationHelper"),
        NotificationStore: new ServiceIdentifier("Neo.UI.NotificationStore")
    }
};
export default NeoTypes;
